<template>
  <page-option :title="$t('profile.persional.persionalinfo')">
    <div class="d-flex justify-center pt-md-12 pt-4">
      <v-card elevation="1" max-width="800px" width="100%">
        <v-list-item class="px-12" two-line>
          <v-list-item-avatar color="#fff" size="72">
            <svg
              fill="none"
              height="72"
              viewBox="0 0 72 72"
              width="72"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M37 0C16.576 0 0 16.576 0 37C0 57.424 16.576 74 37 74C57.424 74 74 57.424 74 37C74 16.576 57.424 0 37 0ZM37 11.1C43.142 11.1 48.1 16.058 48.1 22.2C48.1 28.342 43.142 33.3 37 33.3C30.858 33.3 25.9 28.342 25.9 22.2C25.9 16.058 30.858 11.1 37 11.1ZM37 63.64C27.75 63.64 19.573 58.904 14.8 51.726C14.911 44.363 29.6 40.33 37 40.33C44.363 40.33 59.089 44.363 59.2 51.726C54.427 58.904 46.25 63.64 37 63.64Z"
                fill="#A8A8A8"
              />
            </svg>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text-h5">
              {{ $t('profile.persional.profile') }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t('profile.persional.smw') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <div>
          <div class="d-flex flex-column pa-12">
            <base-form ref="formProfile" @submit="saveProfile">
              <v-col class="pa-0" cols="12" md="6">
                <field-group
                  v-model="model.name"
                  dense
                  label="Tên hiển thị"
                  no-label
                  outlined
                  :rules="rules.name"
                ></field-group>
                <field-group
                  v-model="model.mobile"
                  dense
                  :label="$t('field.mobile')"
                  no-label
                  outlined
                  :rules="rules.mobile"
                ></field-group>
                <!-- <v-col class="py-0" cols="12" md="6">
                  <field-group
                    v-model="model.birthday"
                    dense
                    :label="$t('profile.field.birthday')"
                    no-label
                    outlined
                    type-input="field-date"
                  >
                  </field-group>
                </v-col> -->
                <!-- <v-col class="py-0" cols="12" md="6">
                  <field-group :label="$t('profile.field.gender')">
                    <template #input>
                      <v-radio-group v-model="model.gender" row>
                        <v-radio
                          v-for="item of genderItem"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></v-radio>
                      </v-radio-group>
                    </template>
                  </field-group>
                </v-col> -->
              </v-col>
              <div class="pt-6">
                <v-btn
                  class="px-8 py-2 text-none"
                  color="primary"
                  depressed
                  @click="saveProfile()"
                >
                  Lưu
                </v-btn>
              </div>
            </base-form>
          </div>
        </div>
      </v-card>
    </div>
  </page-option>
</template>

<script>
import rules from '@utils/rules'
import { mapGetters } from 'vuex'
import { genderItem } from '@constant'
import JsonToFormData from '@/src/utils/JsonToFormData'
export default {
  data: (vm) => ({
    model: { name: '', last_name: '', birthday: '', gender: 0, avatar: '' },
    genderItem,
    rules,
  }),
  mounted() {
    this.initdata()
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
  },
  methods: {
    initdata() {
      const {
        name,
        last_name,
        birthday,
        gender,
        avatar_url,
        mobile,
      } = this.currentUser
      this.model = {
        name,
        last_name,
        birthday,
        gender,
        avatar: avatar_url,
        mobile,
      }
    },
    async savePassword(e) {
      if (!(await this.$refs.formPassword.validate())) return
      await this.$store.dispatch('auth/updatePassword', this.password)
    },
    async saveProfile() {
      if (!(await this.$refs.formProfile.validate())) return
      let data = { ...this.model }
      if (
        this.model.avatar &&
        this.model.avatar.includes('data:image/png;base64')
      ) {
        data.avatar_base64 = this.model.avatar
        delete data.avatar
      }
      const res = await this.$store.dispatch(
        'auth/update',
        JsonToFormData(data)
      )
      if (res.data) {
        this.$store.commit(
          'auth/setUser',
          Object.assign(this.currentUser, res.data.data.data)
        )
        this.initdata()
      }
    },
    changeFile(file) {
      this.model.avatar = file
    },
    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1])
      else byteString = unescape(dataURI.split(',')[1])
      // separate out the mime component
      var mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ia], { type: mimeString })
    },
  },
}
</script>
